// extracted by mini-css-extract-plugin
export default {"autoComplete":"IY-z","error":"JY-z","disabled":"KY-z"};